export default "__VITE_ASSET__1b53a216__"